/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2018 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';
import { connect } from '@airglow/store-redux';
import { getRouteVar } from '@nebula/rover';
import SessionList from '../../session-list';
import SessionView from '../../session-view';
import * as P from '../data/pages';

const mapState = state => ({
  page: getRouteVar('page', state)
});

const pageMap = {
  [P.SESSION_LIST]: SessionList,
  [P.SESSION_VIEW]: SessionView
};

const MainContainer = ({ page }) => {
  const Page = pageMap[page] || SessionList;
  return <Page />;
};

export default connect(mapState)(MainContainer);
